export const NO_IMAGE_ID = 'static-stage-photo';
